export const publicHearingData = [
 {
        active: false,
        name: '2025',
        value: '2025',
        items: [
            {
                activeFrom: '19.06.2025',
                name: 'Проектная документация – проект нейтрализации серной кислоты на Надеждинском металлургическом заводе имени Б.И. Колесникова',
                year: '2025',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/material-public-hearings2025.zip',
                    name: '',
                    size: '2 ГБ',
                    type: 'zip'
                }
            }
        ]
    },
    {
        active: false,
        name: '2024',
        value: '2024',
        items: [
            {
                activeFrom: '13.09.2024',
                name: '«Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы: проектная документация«ООО «Медвежий ручей». Рудник «Заполярный». Комбинированная отработка оставшихся запасов вкрапленных руд месторождения «Норильск-1». Автомобильные дороги и трубопроводы подотвальных вод /шифр РЗ-КОМ/», включая материалы оценки воздействия на окружающую среду.»',
                year: '2024',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings-material-public-hearings130924-1.pdf',
                    name: '',
                    size: '381 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '13.09.2024',
                name: '«Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы: проектная документация «Рудник «Заполярный». Комбинированная отработка оставшихся запасов вкрапленных руд месторождения «Норильск-1». ВЛ-110кВ /шифр РЗ-КОМ/», включая материалы оценки воздействия на окружающую среду.»',
                year: '2024',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings-material-public-hearings130924-2.pdf',
                    name: '',
                    size: '379 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '13.09.2024',
                name: '«Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы: проектная документация «Рудник «Заполярный». Комбинированная отработка оставшихся запасов вкрапленных руд месторождения «Норильск-1». Сеть газопотребления /шифр РЗ-КОМ/», включая материалы оценки воздействия на окружающую среду.»',
                year: '2024',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings-material-public-hearings130924-3.pdf',
                    name: '',
                    size: '381 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '10.09.2024',
                name: '«Уведомление о проведении общественных обсуждений по объекту экологической экспертизы по проектной документации ««ТОФ-ПНС-2. Проектирование и установка автоматизированных насосных установок»/шифр ТОФ-ПНС-2/», включая предварительные материалы оценки воздействия на окружающую среду.»',
                year: '2024',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings-material-public-hearings100924.pdf',
                    name: '',
                    size: '88 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '16.08.2024',
                name: '«Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы — проектной документации «Строительство сооружения для размещения цеха по переработке лома цветных металлов» /шифр ПЕСХ-ЦПМ/», включая предварительные материалы оценки воздействия на окружающую среду.»',
                year: '2024',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings-material-public-hearings160824.zip',
                    name: '',
                    size: '83 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '10.04.2024',
                name: '«Уведомление о проведении общественных обсуждений объекта государственной экологической экспертизы: проектной документации «Рудник «Масловский». Очередь 1. Вскрытие и отработка запасов Северного участка. Межплощадочные автомобильные дороги», включая предварительные материалы оценки воздействия на окружающую среду»',
                year: '2024',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings220424.pdf',
                    name: '',
                    size: '84,5 Кб',
                    type: 'pdf'
                }
            }
        ]
    },
    {
        active: false,
        name: '2023',
        value: '2023',
        items: [
            {
                activeFrom: '31.10.2023',
                name: '«Уведомление о проведении общественных обсуждений объекта государственной экологической экспертизы: проектной документации «Рудник «Масловский». Очередь 1. Вскрытие и отработка запасов Северного участка. Межплощадочные автомобильные дороги», включая предварительные материалы оценки воздействия на окружающую среду»',
                year: '2023',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings311023.pdf',
                    name: '',
                    size: '78 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '20.09.2023',
                name: '«Уведомление о проведении общественных обсуждений объекта экологической экспертизы: проектной документации «Рудник «Скалистый» шахта «Глубокая». Вскрытие, подготовка и отработка глубоких залежей богатых и «медистых» руд северных флангов «Октябрьского» месторождения. Газопровод. Отпайки от ВЛ-110 кВ ЛЭП-137 и 138 к ГПП-66»',
                year: '2023',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings200923.pdf',
                    name: '',
                    size: '420 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '18.08.2023',
                name: '«Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы: проектная документация «Ликвидация объектов размещения отходов Никелевого завода. Ликвидация отстойника железистого кека Никелевого завода», включая предварительные материалы оценки воздействия на окружающую среду»',
                year: '2023',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings-material-public-hearings18082023.pdf',
                    name: '',
                    size: '256 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '08.08.2023',
                name: '«Уведомление о проведении общественных обсуждений по объекту экологической экспертизы по проектной документации ПАО «ГМК «Норильский никель». Заполярный филиал. Надеждинский металлургический завод имени Б.И. Колесникова. Нейтрализация серной кислоты, включая предварительные материалы ОВОС»',
                year: '2023',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public_comment_notice_according_to_project_documentation.zip',
                    name: '',
                    size: '324 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '04.07.2023',
                name: '«Уведомление о проведении общественных обсуждений объекта экологической экспертизы: проектной документации «Вскрытие, подготовка и отработка глубоких залежей богатых и «медистых» руд северных флангов «Октябрьского» месторождения шахты «Глубокая» рудника «Скалистый»»',
                year: '2023',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings040723.pdf',
                    name: '',
                    size: '428 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '16.06.2023',
                name: '«Уведомление о проведении общественных обсуждений объекта государственной экологической экспертизы — проектной документации «Рудник «Масловский». Очередь 1. Вскрытие и отработка запасов Северного участка. Строительство вертикальных стволов. Период проходки“, включая предварительные материалы оценки воздействия на окружающую среду»',
                year: '2023',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings160623.pdf',
                    name: '',
                    size: '80 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '06.06.2023',
                name: '«Уведомление о проведении общественных обсуждений объекта экологической экспертизы «АТО «ЦАТК». Строительство промышленного отвала №3», включая предварительные материалы оценки воздействия на окружающую среду. Опросный лист»',
                year: '2023',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings060623.rar',
                    name: '',
                    size: '111 Кб',
                    type: 'rar'
                }
            },
            {
                activeFrom: '24.05.2023',
                name: '«Уведомление о проведении общественных обсуждений объекта государственной экологической экспертизы - проектной документации «Рудник «Масловский». Очередь 1. Вскрытие и отработка запасов Северного участка. Подъездная автомобильная дорога, система водоснабжения», включая предварительные материалы оценки воздействия на окружающую среду»',
                year: '2023',
                file: {
                    link: '/upload/files/ru/sustainability/environment/public-hearings/public-hearings-announcement-240523.pdf',
                    name: '',
                    size: '79,4 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '21.04.2023',
                name: '«Уведомление о проведении общественных обсуждений объекта государственной экологической экспертизы - проектной документации «Рудник «Масловский». Очередь 1. Вскрытие и отработка запасов Северного участка. Система электроснабжения», включая предварительные материалы оценки воздействия на окружающую среду»',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-210423.pdf',
                    name: '',
                    size: '72,9 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '11.04.2023',
                name: 'Уведомление о проведении общественных обсуждений по объекту экологической экспертизы по проектной документации «ПАО «ГМК «Норильский никель». Нейтрализация серной кислоты-2. Гипсохранилище» (шифр: НСК-2, КП-СП), включая предварительные материалы ОВОС.',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-110423.pdf',
                    name: '',
                    size: '81,6 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '06.04.2023',
                name: 'Уведомление о проведении общественных обсуждений по объекту экологической экспертизы «Строительство гаражного комплекса Газоспасательной службы» (проектная документация), включая предварительные материалы оценки воздействия на окружающую среду. Опросный лист.',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-06-04-2023-2.zip',
                    name: '',
                    size: '18,9 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '06.04.2023',
                name: 'Уведомление о проведении общественных обсуждений по объекту экологической экспертизы «НМЗ. Строительство пожарного депо» (проектная документация), включая предварительные материалы оценки воздействия на окружающую среду. Опросный лист.',
                year: '2023',
                file: {
                    link: '',
                    name: '',
                    size: '82,6 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '16.03.2023',
                name: 'Уведомление о проведении общественных обсуждений проекта Технического задания на проведение оценки воздействия на окружающую среду планируемой хозяйственной деятельности по объекту: «Рудник «Масловский». Очередь 1. Вскрытие и отработка запасов Северного участка. Строительство вертикальных стволов. Период проходки»',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-16-03-2023.pdf',
                    name: '',
                    size: '91 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '07.03.2023',
                name: 'Уведомление о проведении общественных обсуждений проекта Технического задания на проведение оценки воздействия на окружающую среду планируемой хозяйственной деятельности по объекту: «Рудник „Масловский“. Очередь 1. Вскрытие и отработка запасов Северного участка. Подъездная автомобильная дорога, система водоснабжения».',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-07-03-2023.pdf',
                    name: '',
                    size: '100 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '11.02.2023',
                name: 'Уведомление о проведении общественных обсуждений по объекту экологической экспертизы «Строительство гаражного комплекса Газоспасательной службы» (проектная документация), включая предварительные материалы оценки воздействия на окружающую среду. Опросный лист.',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-11-02-2023.zip',
                    name: '',
                    size: '105 Кб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '11.02.2023',
                name: 'Уведомление о проведении общественных обсуждений по объекту экологической экспертизы «НМЗ. Строительство пожарного депо» (проектная документация), включая предварительные материалы оценки воздействия на окружающую среду. Опросный лист.',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-11-02-23.rar',
                    name: '',
                    size: '109 Кб',
                    type: 'rar'
                }
            },
            {
                activeFrom: '11.02.2023',
                name: 'Уведомление о проведении общественных обсуждений по объекту экологической экспертизы «Строительство гаражного комплекса Газоспасательной службы» (проектная документация), включая предварительные материалы оценки воздействия на окружающую среду. Опросный лист.',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-11-02-2023.zip',
                    name: '',
                    size: '105 Кб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '01.02.2023',
                name: 'Уведомление о проведении общественных обсуждений проекта Технического задания на проведение оценки воздействия на окружающую среду планируемой хозяйственной деятельности по объекту: «Рудник „Масловский“. Очередь 1 Вскрытие и отработка запасов Северного участка. Система электроснабжения».',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-07-14-0223.pdf',
                    name: '',
                    size: '76,2 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '11.02.2023',
                name: 'Уведомление о проведении общественных обсуждений по объекту экологической экспертизы «НМЗ. Строительство пожарного депо» (проектная документация), включая предварительные материалы оценки воздействия на окружающую среду. Опросный лист.',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-11-02-23.rar',
                    name: '',
                    size: '109 Кб',
                    type: 'rar'
                }
            },
            {
                activeFrom: '24.01.2023',
                name: 'Уведомление о проведении общественных обсуждений по объекту экологической экспертизы по проекту рекультивации «Проект рекультивации земель, нарушенных в результате техногенных проливов вдоль пульпопровода, а также воздействия вдоль автодороги Норильск-Алыкель» (корректировка проекта с учетом работ в водоохранных зонах и землях промышленности), включая предварительные материалы ОВОС.',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-240123.pdf',
                    name: '',
                    size: '236 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '07.01.2023',
                name: 'Уведомление о проведении общественных обсуждений по объекту экологической экспертизы «АТО „ЦАТК“. Строительство промышленного отвала № 3» (проектная документация), включая предварительные материалы оценки воздействия на окружающую среду. Опросный лист.',
                year: '2023',
                file: {
                    link: '/files/ru/public-hearings-announcement-070123.pdf',
                    name: '',
                    size: '111 Кб',
                    type: 'pdf'
                }
            }

        ]
    },
    {
        active: false,
        name: '2022',
        value: '2022',
        items: [
            {
                activeFrom: '23.12.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы — проектной документации: «Реконструкция холодных складов № 1,2» /шифр: РИ НПР-РХС-ПЕСХ/, включая предварительные материалы оценки воздействия на окружающую среду (ОВОС).',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-231222-1.pdf',
                    name: 'public-hearings-announcement-231222-1.pdf',
                    size: '170 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '23.12.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы — проектной документации: «Три теплых объекта на территории ТПЦ № 1 ПЕСХ» /шифр: РИ НПР-БТСА-ПЕСХ/, включая предварительные материалы оценки воздействия на окружающую среду (ОВОС).',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-231222-2.pdf',
                    name: 'public-hearings-announcement-231222-2.pdf',
                    size: '307 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '23.12.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы — проектной документации: «Холодный объект на ТПУ № 2 ТПЦ № 3 ПЕСХ» /шифр: РИ НПР-БХСК-ПЕСХ/, включая предварительные материалы оценки воздействия на окружающую среду (ОВОС).',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-231222-3.pdf',
                    name: 'public-hearings-announcement-231222-3.pdf',
                    size: '326 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '23.12.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы — проектной документации: «Реконструкция складского комплекса. Блок № 5 тёплый склад БИО ТПУ-2 ТПЦ-3» /шифр: РИ НПР-ПЕСХ-Б5/, включая предварительные материалы оценки воздействия на окружающую среду (ОВОС).',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-231222-4.pdf',
                    name: 'public-hearings-announcement-231222-4.pdf',
                    size: '308 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '18.11.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы — проектной документации «Реконструкция здания комплекс „Валек“, расположенного по адресу: Красноярский край, район города Норильска, 11 км Вальковского шоссе, 34, для размещения сотрудников, необходимых для реализации Стратегических проектов Компании» /шифр РИ НПР-Валек/, включая предварительные материалы оценки воздействия на окружающую среду (ОВОС).',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-171122.pdf',
                    name: 'public-hearings-announcement-171122.pdf',
                    size: '226 Кб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '03.11.2022',
                name: 'Уведомление о проведении общественных обсуждений по проектной документации ПАО «ГМК «Норильский никель». Надеждинский металлургический завод имени Б.И. Колесникова. Нейтрализация серной кислоты. Шифр: НМЗ-НСК (КП-СП) с приложением тома ОВОС, опросного листа и самого уведомления.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-191222-N.zip',
                    name: 'public-hearings-announcement-191222-N.zip',
                    size: '160 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '23.09.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы — проектной документации «Реконструкция здания комплекс „Валек“, расположенного по адресу: Красноярский край, район города Норильска, 11 км Вальковского шоссе, 34, для размещения сотрудников, необходимых для реализации Стратегических проектов Компании» /шифр РИ НПР-Валек/, включая предварительные материалы оценки воздействия на окружающую среду (ОВОС)',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-230922.pdf',
                    name: 'public-hearings-announcement-230922.pdf',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '20.09.2022',
                name: 'Уведомление о проведении общественных обсуждений по проектной документации «Реконструкция и техническое перевооружение ТОФ с увеличением мощности до 18 млн. тонн в год по сумме руд. Корректировка 2-й очереди строительства хвостохранилища ТОФ», включая предварительные материалы ОВОС',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-061022.pdf',
                    name: 'public-hearings-announcement-061022.pdf',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '26.07.2022',
                name: 'Уведомление о проведении общественных обсуждений объекта государственной экологической экспертизы (проектной документации): «НМЗ. КС-1. КАПИТАЛЬНОЕ СТРОИТЕЛЬСТВО ВРУ ПРОИЗВОДИТЕЛЬНОСТЬЮ 40 ТЫС. М3/Ч. ПРИМЕНЕНИЕ ВАКУУМНОЙ КОРОТКОЦИКЛОВОЙ АДСОРБЦИИ», включая предварительные материалы оценки воздействия на окружающую среду',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-020822.pdf',
                    name: 'public-hearings-announcement-020822.pdf',
                    size: '0,2 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '27.05.2022',
                name: 'Уведомление о проведении общественных обсуждений объекта экологической экспертизы «Предприятие „Единой складское хозяйство“ база ТМИО № 2 ТПЦ-1. Строительство сооружения для размещения цеха по переработке лома цветных металлов», включая предварительные материалы оценки воздействия на окружающую среду. Опросный лист.',
                year: '2022',
                file: {
                    link: '/files/ru/uvedomlenie_270522.rar',
                    name: 'uvedomlenie_270522.rar',
                    size: '0,2 Мб',
                    type: 'rar'
                }
            },
            {
                activeFrom: '20.04.2022',
                name: 'Уведомление о проведении общественных обсуждений объекта экологической экспертизы «Комплексное развитие рудника „Октябрьский“. Поверхностный закладочный комплекс № 2 (ПЗК2)», включая предварительные материалы оценки воздействия на окружающую среду. Опросный лист.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-2004.pdf',
                    name: 'public-hearings-announcement-2004.pdf',
                    size: '0,4 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '19.04.2022',
                name: 'Уведомление о проведении общественных обсуждений по проектной документации ПАО «ГМК «Норильский никель». Заполярный филиал. Медный завод. Утилизация диоксида серы. Существующие сети. Шифр: МЗ-УДС (КП-СП), включая предварительные материалы оценки воздействия на окружающую среду, опросные листы.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-190422-1.zip',
                    name: 'public-hearings-announcement-190422-1.zip',
                    size: '9,66 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '19.04.2022',
                name: 'Уведомление о проведении общественных обсуждений по проектной документации ПАО «ГМК «Норильский никель». Заполярный филиал. Медный завод. Утилизация диоксида серы. Железнодорожные пути № 14 и № 15. Шифр: МЗ-УДС (КП-СП), включая предварительные материалы оценки воздействия на окружающую среду, опросные листы.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-190422-2.zip',
                    name: 'public-hearings-announcement-190422-2.zip',
                    size: '9,72 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '19.04.2022',
                name: 'Уведомление о проведении общественных обсуждений по проектной документации ПАО «ГМК «Норильский никель». Заполярный филиал. Медный завод. Утилизация диоксида серы. Системы теплоснабжения. Шифр: МЗ-УДС (КП-СП), включая предварительные материалы оценки воздействия на окружающую среду, опросные листы.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-190422-3.zip',
                    name: 'public-hearings-announcement-190422-3.zip',
                    size: '10,8 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '19.04.2022',
                name: 'Уведомление о проведении общественных обсуждений по проектной документации ПАО «ГМК «Норильский никель». Заполярный филиал. Медный завод. Утилизация диоксида серы. Системы утилизации тепла. Шифр: МЗ-УДС (КП-СП), включая предварительные материалы оценки воздействия на окружающую среду, опросные листы.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-190422-4.zip',
                    name: 'public-hearings-announcement-190422-4.zip',
                    size: '9,2 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '19.04.2022',
                name: 'Уведомление о проведении общественных обсуждений по проектной документации ПАО «ГМК «Норильский никель». Заполярный филиал. Медный завод. Утилизация диоксида серы. Производство серной кислоты. Шифр: МЗ-УДС (КП-СП), включая предварительные материалы оценки воздействия на окружающую среду, опросные листы.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-190422-5.zip',
                    name: 'public-hearings-announcement-190422-5.zip',
                    size: '16,3 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '10.03.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы: проектная документация «ПАО «ГМК «Норильский никель». АО «Кольская ГМК». Строительство комплекса «Обжиг — Выщелачивание — Электроэкстракция». 2 этап строительства. Подготовка сырья», включая предварительные материалы оценки воздействия на окружающую среду.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-100322-3.pdf',
                    name: 'public-hearings-announcement-100322-3.pdf',
                    size: '0,39 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '10.03.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы: проектная документация «ПАО «ГМК «Норильский никель». АО «Кольская ГМК». Строительство отделения разделения файнштейна. 3 этап строительства. Сети внутриплощадочные», включая предварительные материалы оценки воздействия на окружающую среду.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-100322-2.pdf',
                    name: 'public-hearings-announcement-100322-2.pdf',
                    size: '0,33 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '10.03.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы: проектная документация «ПАО «ГМК «Норильский никель». АО «Кольская ГМК». Строительство отделения разделения файнштейна. 4 этап строительства. Объекты основного производства», включая предварительные материалы оценки воздействия на окружающую среду.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-100322-1.pdf',
                    name: 'public-hearings-announcement-100322-1.pdf',
                    size: '0,33 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '09.03.2022',
                name: 'Уведомление о проведении общественных обсуждений ОВОС проекта НМЗ НКХ.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-090322-3.pdf',
                    name: 'public-hearings-announcement-090322-3.pdf',
                    size: '0,32 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '09.03.2022',
                name: 'Уведомление о проведении общественных обсуждений ОВОС проекта КС-2.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-090322-2.pdf',
                    name: 'public-hearings-announcement-090322-2.pdf',
                    size: '0,32 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '09.03.2022',
                name: 'Уведомление о проведении общественных обсуждений ОВОС проекта НМЗ-3ПК.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-090322-1.pdf',
                    name: 'public-hearings-announcement-090322-1.pdf',
                    size: '0,32 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '25.02.2022',
                name: 'Уведомление о проведении общественных обсуждений объекта государственной экологической экспертизы (проектная документация): "МЗ. Техническое перевооружение приемки кислорода с Кислородной станции № 1", включая предварительные материалы оценки воздействия на окружающую среду.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-250222.pdf',
                    name: 'public-hearings-announcement-250222.pdf',
                    size: '0,12 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '28.01.2022',
                name: 'Документация проекта «Строительство комплекса «Обжиг — Выщелачивание — Электроэкстракция». 1 этап строительства. Административно-бытовой корпус, контейнерная площадка».',
                year: '2022',
                file: {
                    link: '/upload/public-hearings-announcement-280122-1.zip',
                    name: 'public-hearings-announcement-280122-1.zip',
                    size: '1,48 Гб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '28.01.2022',
                name: 'Документация проекта «Строительство отделения разделения файнштейна. 1 этап строительства. АБК. Контейнерная площадка».',
                year: '2022',
                file: {
                    link: '/upload/public-hearings-announcement-280122-2.zip',
                    name: 'public-hearings-announcement-280122-2.zip',
                    size: '980 Мб',
                    type: 'zip'
                }
            },
            {
                activeFrom: '24.01.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы: проектная документация «ПАО «ГМК «Норильский Никель». «АО «Кольская ГМК». Строительство отделения разделения файнштейна. 1 этап строительства. АБК. Контейнерная площадка», включая предварительные материалы оценки воздействия на окружающую среду.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-240122-1.pdf',
                    name: '',
                    size: '0,39 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '24.01.2022',
                name: 'Уведомление о проведении общественных обсуждений по объекту государственной экологической экспертизы: проектная документация «ПАО «ГМК «Норильский никель». АО «Кольская ГМК». Строительство комплекса «Обжиг — Выщелачивание — Электроэкстракция». 1 этап строительства. Административно-бытовой корпус, контейнерная площадка», включая предварительные материалы оценки воздействия на окружающую среду.',
                year: '2022',
                file: {
                    link: '/files/ru/public-hearings-announcement-240122-2.pdf',
                    name: '',
                    size: '0,38 Мб',
                    type: 'pdf'
                }
            }
        ]
    },
    {
        active: false,
        name: '2021',
        value: '2021',
        items: [
            {
                activeFrom: '28.12.2021',
                name: 'Уведомление о проведении общественных обсуждений проектной документации, включая предварительные материалы оценки воздействия на окружающую среду, по объекту: «НМЗ. Реконструкция пожарного депо».',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement-281221.pdf',
                    name: '',
                    size: '0,16 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '24.12.2021',
                name: 'Уведомление о проведении общественных обсуждений проектной документации, включая предварительные материалы оценки воздействия на окружающую среду, по объекту: «ЗФ ПАО «ГМК „Норильский никель“. Рудник „Октябрьский“. Реконструкция шахтного подъемного комплекса СС-1».',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement-241221.pdf',
                    name: '',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '21.12.2021',
                name: 'Уведомление о проведении общественных обсуждений по материалам проектной документации «Оценка воздействия на окружающую среду» по проекту: «Рудник „Скалистый“. Каскадный водоотлив» (шифр РС-КВ).',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement-211221.pdf',
                    name: '',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '08.12.2021',
                name: 'Уведомление о проведении общественных обсуждений проектной документации «ПАО «ГМК „Норильский никель“. Нейтрализация серной кислоты-2. Объекты нейтрализации Медного завода» (шифр: НСК-2, КП-СП).',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement-0812.pdf',
                    name: '',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '18.11.2021',
                name: 'Уведомление о проведении общественных обсуждений объекта экологической экспертизы: проектной документации, включая предварительные материалы оценки воздействия на окружающую среду. «Рудник „Таймырский“. Вскрытие, подготовка и отработка залежей богатых руд С-3 и С-4 и всех запасов „медистых“ и вкрапленных руд»',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement-1811.pdf',
                    name: '',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '18.10.2021',
                name: 'Рудник «Скалистый». Каскадный водоотлив',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement.pdf',
                    name: '',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '02.11.2021',
                name: 'Уведомление о проведении общественных обсуждений проектной документации «Комплексное развитие рудника „Октябрьский“. Реконструкция с увеличением производственной мощности с 5,2 до 7,2 млн тонн в год», включая предварительные материалы оценки воздействия на окружающую среду.',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement-0211-1.pdf',
                    name: '',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '02.11.2021',
                name: 'Уведомление о проведении общественных обсуждений проектной документации «Комплексное развитие рудника „Октябрьский“. Административно-бытовой комплекс», включая предварительные материалы оценки воздействия на окружающую среду.',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement-0211-2.pdf',
                    name: '',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '02.11.2021',
                name: 'Уведомление о проведении общественных обсуждений проектной документации «Комплексное развитие рудника „Октябрьский“. Ремонтно-складское хозяйство», включая предварительные материалы оценки воздействия на окружающую среду.',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement-0211-3.pdf',
                    name: '',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '02.11.2021',
                name: 'Уведомление о проведении общественных обсуждений проектной документации «Комплексное развитие рудника „Октябрьский“. Реконструкция энергетического комплекса», включая предварительные материалы оценки воздействия на окружающую среду.',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement-0211-4.pdf',
                    name: '',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            },
            {
                activeFrom: '09.11.2021',
                name: 'Общественные обсуждения. Рудник «Скалистый». Каскадный водоотлив.',
                year: '2021',
                file: {
                    link: '/files/ru/public-hearings-announcement-5.pdf',
                    name: '',
                    size: '0,1 Мб',
                    type: 'pdf'
                }
            }
        ]
    }
]
